import { SET_CHECKLIST_SELECTED_ITEM } from '../constants/ActionTypes';

const initialState = {
  selectedIndex: 0,
};

export default function checklistSelectedItem(state = initialState, action) {
  switch (action.type) {
    case SET_CHECKLIST_SELECTED_ITEM:
      return {
        ...state,
        selectedIndex: action.payload,
      };
    default:
      return state;
  }
}
